import { useAnalytics } from '../contexts/AnalyticsContext';
import { useShare } from './useShare';

interface Props {
  url: string;
  shareText: string;
  context: string;
}

export const useShareLink = ({ url, shareText, context }: Props) => {
  const { track } = useAnalytics();
  return useShare({
    url,
    text: shareText,
    onShareSuccess: (native) => track('Link Shared', { context, native }),
  });
};
